import React from 'react';
import { Row, Col } from 'antd';
import { rowThumbnailProps } from 'src/utils/grid';
import { GlobalCta } from 'src/modules/global';
import { CtaProps } from 'src/modules/global/components/cta/Cta';
import styles from './LayoutBlockText.module.scss';
import { useMatchesChannel, ChannelsFullNames } from 'src/modules/locale';

export interface LayoutBlockTextProps {
  title?: string;
  caption?: React.ReactNode;
  body_text: string;
  channel?: ChannelsFullNames;
  button?: CtaProps;
}

const LayoutBlockText: React.FunctionComponent<LayoutBlockTextProps> = (
  props: LayoutBlockTextProps
) => {
  const { title, caption, body_text, button } = props;

  return (
    <div className={styles.container}>
      <Row {...rowThumbnailProps}>
        <Col xs={24} md={{ span: 12, offset: 6 }}>
          {title && <h3 className={styles.title}>{title}</h3>}
          {caption && <div className={styles.caption}>{caption}</div>}
        </Col>
      </Row>
      <Row {...rowThumbnailProps}>
        <Col xs={24} md={{ span: 12, offset: 6 }}>
          <div dangerouslySetInnerHTML={{ __html: body_text }} />
        </Col>
      </Row>
      {!!button && <GlobalCta {...button} align={true} />}
    </div>
  );
};

const LayoutBlockTextWithOutputChannel = (props: LayoutBlockTextProps) => {
  const matchesChannel = useMatchesChannel(props.channel);
  if (!matchesChannel) return null;

  return <LayoutBlockText {...props} />;
};

export default LayoutBlockTextWithOutputChannel;
